import { Collapse } from '@/shared/common/collapse/collapse';

const productsCollapse = document.querySelector('.js-main-products-collapse');

export const mainProductsCollapse = () => {
	productsCollapse &&
		new Collapse(productsCollapse, {
			selectorElement: '.js-main-products-collapse > .collapse__element',
			selectorButton: '.collapse__button',
			selectorContent: '.collapse__content',
		});
};
